import React, { useState, useEffect } from "react";
import axiosConn from "config/axiosConn";
import { useNavigate } from "react-router-dom";
import { FormGroup, Form, Input, Row, Col } from "reactstrap";
import { jwtDecode } from 'jwt-decode';
import Helper from "../../helper/Common_Helper.js";
import { handleSpeak, handleSpeakWithoutVoice } from './speechHandlers.js';
import { handleFocusChange, skipFocusChange } from './formUtils.js';
import InputField from "./InputField.jsx";
import "react-toastify/dist/ReactToastify.css";
import { useSpeechRecognition } from "react-speech-recognition";
import { Formik, Field, ErrorMessage } from "formik";
import { useRef } from 'react';
import { useSelector } from "react-redux";
import Langfield from "../../assets/Json/eventAssignment.json";
import { FastForward } from "phosphor-react";
import * as Yup from "yup";
import VirtualKeyboard from "./VirtualKeyboard/VirtualKeyboard.jsx";
import SideBar from "./SideBar";
import { Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import isEmail from 'validator/lib/isEmail';
import { changeLang, selectedVoice } from '../../redux/langSlice'
import { useDispatch } from 'react-redux'
import { FaBarsStaggered } from "react-icons/fa6";
import { Link } from "react-router-dom";
import StateList from "../../helper/State_List.json";
import DistrictList from "../../helper/District_List.json";

// import { useSelector } from "react-redux";

function FacultyManagement() {
    const [openSidebar, setOpenSidebar] = useState(false);
    
    const navigate = useNavigate() 
    const [registeredFaculties, setRegisteredFaculties] = useState([]);
    const [role, setRole] = useState('');
    const [udise, setUDISE] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);
     const userData = useSelector(state => state.auth.user);
    const langSelected = userData.lang;
    // const [voiceSelected, setVoiceSelected] = useState('en-IN-NeerjaNeural');
    const voiceSelected = userData.voice;
    const [isEmpty, setIsEmpty] = useState(false);
    const [filterDistrict, setFilterDistrict] = useState([]);
    const [slectedState, setState] = useState("");
    const [slectedDistrict, setDistrict] = useState("");
    const [initialValues, setInitialValues] = useState({
        udise_id: "",
        school_name: "",
        teacher_name: "",
        email: "",
        teacher_id: "",
        mobile: "",
        state: "",
        district: "",
    });

    const disableRef = useRef(false);
    const nextValueRef = useRef(0);
    const resetRef = useRef(0);
    const translations = Langfield[langSelected];
    const translate = (key) => {
        // Check if translations is defined and is an object
        if (typeof translations !== "object" || translations === null) {
          return key; // Return the key if translations is not available
        }
    
        // Handle undefined or non-string keys
        if (typeof key !== "string") {
          return key; // Return the value as is if key is not a string
        }
    
        return translations[key] || key.replace(/_/g, " "); // Use translation or fallback to the key
      };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInitialValues({
      ...initialValues,
      [name]: value,
    });
    setIsEmpty(false)
  };

    const teacherNameRef = useRef(null);
    const emailRef = useRef(null);
    const teacherIdRef = useRef(null);
    const mobileRef = useRef(null);
    const stateRef = useRef(null);
    const districtRef = useRef(null);
    const onBtnRef = useRef(null);
    const isKeyBoardInput = useRef(false);
    const { browserSupportsSpeechRecognition, listening, transcript, resetTranscript } = useSpeechRecognition();
    const getActiveState = useRef("teacher_name");
    const [getActive, setActive] = useState("");

    const nextRef = [
        teacherNameRef,
        emailRef,
        teacherIdRef,
        mobileRef,
        stateRef,
        districtRef
    ]
    let timer = null;

    const handleActive = (e) => {
        const elementId = e.target.id;
        setActive(elementId);
    };

    useEffect(() => {
        
        if (userData) {
            // let auth = jwtDecode(token)
            // console.log(auth,"auth")
            setInitialValues({ ...initialValues, udise_id: userData.udise_id, school_name: userData.school_name, state: userData.state, district: userData.district });

            // getLanguageFunction({ udise_id: userData.udise_id })
            setRole(userData.role);
            setState(userData.state);
            setDistrict(userData.district);
            // Populate districts if state is available
            if (userData.state) {
                const stateInfo = StateList.find(obj => obj.state_id == userData.state || obj.state_name === userData.state);
                if (stateInfo) {
                    const filteredDistricts = DistrictList.filter(obj => obj.state_id == stateInfo.state_id);
                    setFilterDistrict(filteredDistricts);
                }
            }
        }
    }, [userData]);

    // const getLanguageFunction = async (data) => {
    //     try {
    //         const response = await axiosConn('post', 'get-language', data)

    //         if (response.data.status === 'success') {
    //             let lang = response.data.result.lang;
    //             let voice = response.data.result.voice;
    //             setLangSelected(lang);
    //             setVoiceSelected(voice);
    //             dispatch(changeLang(lang));
    //             dispatch(selectedVoice(voice));
    //             localStorage.setItem('langCode', lang);
    //             localStorage.setItem('voice', voice);
    //         }
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }

    const handleSelectState = (stateId) => {
        setState(stateId);
        setInitialValues({ ...initialValues, state: stateId, district: "" });
        setDistrict("");
        const filteredDistricts = DistrictList.filter(obj => obj.state_id == stateId);
        setFilterDistrict(filteredDistricts);
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isSubmitting) return;
            setIsSubmitting(true);
    
            // Validation
            if (!initialValues.district || initialValues.district === "Select District" || initialValues.district === "") {
                setIsSubmitting(false);
                setIsEmpty(true);
                setTimeout(() => setIsEmpty(false), 3000);
                toast.warning(translate("Please select a district."));
                return;
            }
    
            let postData = initialValues;
    
            if (initialValues.mobile.length !== 10) {
                setIsSubmitting(false)
                setIsEmpty(true);
                setTimeout(() =>  setIsEmpty(false), 3000);
                toast.warning(translate("Contact number should be 10 digits"));
                return;
            }
    
            if (!isEmail(initialValues.email)) {
                setIsEmpty(true);
                setIsSubmitting(false)
                setTimeout(() =>  setIsEmpty(false), 3000);
                toast.warning(translate("Please enter a valid email address"));
                return;
            }
    
            postData['username'] = initialValues.email;
            postData['role'] = 3;
            postData['password'] = "Asd@1234";
            postData['school_name'] = initialValues.school_name;
    
            // Always use the district ID for submission
            if (initialValues.district && initialValues.district !== "Select District" && initialValues.district !== "") {
                postData["district"] = initialValues.district;
            }
    
            const response = await axiosConn('post', `faculty-register`, postData, {
                headers: { 'Content-Type': 'application/json' }
            });
    
            if (response.data.status === 'success') {
                getFaculties({ udise_id: udise }, currentPage);
                setInitialValues({
                    teacher_name: "",
                    email: "",
                    teacher_id: "",
                    mobile: "",
                    state: "",
                    district: "",
                });
                toast.success(translate("Faculty Registered Successfully!"));
            }else{
                toast.error(response.data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error(translate("Error in registering faculty. Please try again."));
        } finally {
            setTimeout(() => setIsSubmitting(false), 1000);
        }
    };
    

    useEffect(() => {
        // let token = localStorage.getItem('token');
        
        if (userData) {
            // let auth = jwtDecode(token)
            getFaculties({ udise_id: userData.udise_id });
            setUDISE(userData.udise_id);
        }
    }, [userData]);

    const getFaculties = async (data, page = 1) => {
        try {
            data['page'] = page;
            data['limit'] = 5;
            let response = await axiosConn('post', "get-registered-faculties", data,{},dispatch);
            console.log(response.data, "response")
            if (response.data.status === "success") {
                setRegisteredFaculties(response.data.data)
                setTotalPages(response.data.totalPages);
                setCurrentPage(response.data.currentPage);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            getFaculties({ udise_id: udise }, page);
        }
    };

    const handleActiveStatus = async (email, status, isActive) => {
        // Optimistic UI update
        setRegisteredFaculties(prevFaculties =>
            prevFaculties.map(faculty =>
                faculty.email === email ? { ...faculty, isActive: isActive } : faculty
            )
        );

        try {
            let data = { email, status, isActive }
            let response = await axiosConn('post', "update-faculty-status", data, {}, dispatch);
            if (response.data.status === "success") {
                toast.success(response.data.message || "Status updated successfully");
                getFaculties({ udise_id: udise }, currentPage)
            } else {
                toast.error(response.data.message || "Failed to update status");
            }
        } catch (error) {
            console.log(error);
            toast.error("Failed to update status");
        }
    }

    const facultyOptions = registeredFaculties && registeredFaculties.map((item) => ({
        value: item._id,
        teacher_id: item.teacher_id,
        faculty_email: item.email,
        label: `Faculty-ID (${item.teacher_id}) - ${item.teacher_name}`,
    }));

    if (!browserSupportsSpeechRecognition) {
        return <span>Browser doesn't support speech recognition.</span>;
    }

    const InputFields = [
        {
            name: "teacher_name", label: translate("Name_of_Faculty"), type: "text", required: true, placeholder: translate("Name_of_Faculty"), innerRef: teacherNameRef,
            handleSpeak: (label) => handleSpeak(label, langSelected, voiceSelected, getActiveState, onBtnRef, translate("Name_of_Faculty")),
        },
        {
            name: "email", label: (
                <>
                  {translate("Email")}{""}<span style={{ color: "red" }}>*</span>
                </>
              ), type: "text", required: false, placeholder: translate("Email"), innerRef: emailRef,
            handleSpeak: (label) => handleSpeak(label, langSelected, voiceSelected, getActiveState, onBtnRef, translate("Email")),
        },
        {
            name: "teacher_id", label: (
                <>
                {translate("Employee Id")}{""}<span style={{color: "red" }}>*</span>
                </>
            ), type: "text", required: false, placeholder: translate("Employee Id"), innerRef: teacherIdRef,
            handleSpeak: (label) => handleSpeak(label, langSelected, voiceSelected, getActiveState, onBtnRef, translate("Employee Id")),
        },
        {
            name: "mobile", label: (
                <>
            {translate("Contact Number")}{""}<span style={{ color: "red" }}>*</span>
                </>
        ), type: "text", required: false, placeholder: translate("Contact Number"), innerRef: mobileRef,
            handleSpeak: (label) => handleSpeak(label, langSelected, voiceSelected, getActiveState, onBtnRef, translate("Contact Number")),
        },
        {
            name: "state",
            label: (
                <span>
                  {translate("State")}{""}
                  <span style={{ color: "red" }}>*</span>
                </span>
            ),
            type: "select",
            required: true,
            selectOptions: StateList.map((obj) => ({
                label: obj.state_name,
                value: obj.state_id,
            })),
            innerRef: stateRef,
            handleSpeak: (label) =>
                handleSpeak(
                    label,
                    langSelected,
                    voiceSelected,
                    getActiveState,
                    onBtnRef,
                    translate("State")
                ),
        },
        {
            name: "district",
            label: (
                <span>
                  {translate("District")}
                  <span style={{ color: "red" }}>*</span>
                </span>
            ),
            type: "select",
            required: true,
            value: initialValues.district || "",
            selectOptions: [
                { label: translate("Select District"), value: "" },
                ...filterDistrict.map((obj) => ({
                    label: obj.district_name,
                    value: obj.district_id,
                })),
            ],
            innerRef: districtRef,
            handleSpeak: (label) =>
                handleSpeak(
                    label,
                    langSelected,
                    voiceSelected,
                    getActiveState,
                    onBtnRef,
                    translate("District")
                ),
        },

    ]

    const renderInputFields = (fieldConfig, setFieldValue, size = 4) => {
        return fieldConfig.type === "select" ? (
            <div
                key={fieldConfig.name}
                onFocus={(e) => { handleActive(e) }}
                className={`col-${size} form-group ${getActive === fieldConfig.name ? "active" : null
                    } `}
            >
                <label htmlFor={fieldConfig.name}>{fieldConfig.label}</label>
                <div className="formgroupIn">
                    <Field
                        onFocus={(e) => {
                            getActiveState.current = fieldConfig.name;
                            handleActive(e);
                            handleSpeakWithoutVoice(fieldConfig.name, langSelected, voiceSelected, getActiveState, fieldConfig.label);
                        }}
                        innerRef={fieldConfig.innerRef}
                        as="select"
                        className="form-control"
                        id={fieldConfig.name}
                        name={fieldConfig.name}
                        value={fieldConfig.value}
                        disabled={
                            (disableRef.current === true
                                ? getActive === fieldConfig.name
                                    ? false
                                    : false
                                : false) || fieldConfig.disabled
                        }
                        onChange={
                            (e) => { 
                                setIsEmpty(false);
                                if (fieldConfig.name === "state") {
                                    handleSelectState(e.target.value);
                                } else {
                                    setInitialValues({ ...initialValues, [fieldConfig.name]: e.target.value });
                                }
                                handleFocusChange(nextRef, nextValueRef, resetRef, timer)
                            }}
                    >
                        {fieldConfig.selectOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {translate(option.label)}
                            </option>
                        ))}
                    </Field>
                </div>
            </div>
        ) : fieldConfig.type === "file" ? (
            <div
                onFocus={(e) => handleActive(e)}
                className={` col-${size}  form-group ${getActive === "file" ? "active" : null
                    }`}
            >
                <label htmlFor="">
                    {translate(
                        "Bank/Branch_to_affix_rubber_stamp_of_name_and_code_number"
                    )}
                </label>

                <div className="formgroupIn">
                    <Field
                        name="file"
                        type="file"
                        id="file"
                        className="form-control"
                        disabled={
                            (disableRef.current === true
                                ? getActive === fieldConfig.name
                                    ? false
                                    : true
                                : false) || fieldConfig.disabled
                        }
                    />
                </div>
                <ErrorMessage name="file" component="div" />
            </div>
        ) : fieldConfig.type === "date" ? (
            <div

                ref={fieldConfig.innerRef}
                onFocus={(e) => {
                    getActiveState.current = fieldConfig.name;
                    handleActive(e);
                    handleSpeakWithoutVoice(fieldConfig.name, langSelected, voiceSelected, getActiveState, fieldConfig.label);
                }}
                className={` col-${size}  form-group ${getActive === fieldConfig.name ? "active" : null
                    }`}
            >
                {getActive === fieldConfig.name && (
                    <div
                        className="skipBtn"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            skipFocusChange(nextRef, nextValueRef, handleFocusChange, resetRef, timer);
                        }}
                    >
                        {translate("Skip")} <FastForward size={18} />
                    </div>
                )}
                <label htmlFor={fieldConfig.name}>{fieldConfig.label}</label>
                <div className="formgroupIn">
                    <Input name="event_date" min={Helper.currentOrFutureDate()} placeholder="" type="datetime-local" value={initialValues.event_date} onChange={handleInputChange} />
                    <span className="inptIcn"></span>
                </div>
            </div>
        ) :
            fieldConfig.type === "text" ? (
                <InputField
                    initialValues={initialValues}
                    setInitialValues={setInitialValues}
                    // saveField={saveField}
                    key={fieldConfig.name}
                    name={fieldConfig.name}
                    value={initialValues[fieldConfig.name]}
                    disabled={fieldConfig.disabled}
                    label={fieldConfig.label}
                    placeholder={fieldConfig.placeholder}
                    innerRef={fieldConfig.innerRef}
                    handleSpeak={fieldConfig.handleSpeak}
                    handleFocusChange={handleFocusChange}
                    nextRef={nextRef}
                    nextValueRef={nextValueRef}
                    resetRef={resetRef}
                    timer={timer}
                    size={size}
                    setFieldValue={setFieldValue}
                    getActive={getActive}
                    handleActive={handleActive}
                    langSelected={langSelected}
                    getActiveState={getActiveState}
                    onBtnRef={onBtnRef}
                    skipFocusChange={skipFocusChange}
                    skipBtn={translate("Skip")}
                    transcript={transcript}
                    listening={listening}
                    voiceSelected={voiceSelected}
                    resetTranscript={resetTranscript}
                    required={fieldConfig.required}
                    isKeyBoardInput={isKeyBoardInput}
                    handleSpeakWithoutVoice={handleSpeakWithoutVoice}
                    disableRef={disableRef}
                    requiredBtn={translate("Required")}
                />
            ) :
                fieldConfig.disabled ? (
                    <div
                        onFocus={(e) => handleActive(e)}
                        className={` col-6  form-group ${getActive === fieldConfig.name ? "active" : null
                            }`}
                    >
                        <label htmlFor={fieldConfig.name}>{fieldConfig.label}</label>
                        <div className="formgroupIn">
                            <Field
                                onFocus={(e) => {
                                    getActiveState.current = fieldConfig.name;
                                    handleActive(e);
                                    handleSpeakWithoutVoice(fieldConfig.name, langSelected, voiceSelected, getActiveState, fieldConfig.label);
                                }}
                                innerRef={fieldConfig.innerRef}
                                type={fieldConfig.type}
                                className="form-control"
                                id={fieldConfig.name}
                                name={fieldConfig.name}
                                placeholder={fieldConfig.placeholder}
                                disabled={fieldConfig.disabled}
                            />
                            <span className="inptIcn"></span>
                        </div>
                    </div>
                ) :

                    (
                        <InputField
                            size={size}
                            initialValues={initialValues}
                            setInitialValues={setInitialValues}
                            // saveField={saveField}
                            key={fieldConfig.name}
                            name={fieldConfig.name}
                            value={initialValues[fieldConfig.name]}
                            disabled={fieldConfig.disabled}
                            label={fieldConfig.label}
                            placeholder={fieldConfig.placeholder}
                            innerRef={fieldConfig.innerRef}
                            handleSpeak={fieldConfig.handleSpeak}
                            handleFocusChange={handleFocusChange}
                            nextRef={nextRef}
                            nextValueRef={nextValueRef}
                            resetRef={resetRef}
                            timer={timer}
                            setFieldValue={setFieldValue}
                            getActive={getActive}
                            handleActive={handleActive}
                            langSelected={langSelected}
                            getActiveState={getActiveState}
                            onBtnRef={onBtnRef}
                            skipFocusChange={skipFocusChange}
                            skipBtn={translate("Skip")}
                            transcript={transcript}
                            listening={listening}
                            voiceSelected={voiceSelected}
                            resetTranscript={resetTranscript}
                            required={fieldConfig.required}
                            isKeyBoardInput={isKeyBoardInput}
                            handleSpeakWithoutVoice={handleSpeakWithoutVoice}
                            disableRef={disableRef}
                            requiredBtn={translate("Required")}
                        />
                    );
    };
    const handleSidebar = () => {
        setOpenSidebar(!openSidebar);
    }

    return (
        <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={Yup.object().shape({})}
            onSubmit={(values, { setSubmitting }) => {
                setSubmitting(false);
            }}
        >
            {({ values, errors, touched, setFieldValue }) => (
                <Form className="bg-blue-900">
                    <section className="scholdashbrdSec">
                        <div className="desktopView" style={{ marginTop: 70, textAlign: "end" }}>
                            <Link className="button green bars" onClick={handleSidebar}><FaBarsStaggered size={20} /></Link>
                        </div>
                        <div className={`sidebar ${openSidebar ? "open" : "hideen"}`}>
                            <SideBar langSelected={langSelected} index={7} role={role} />
                        </div>
                        <div className="schlDashbrdRgt">
                            <div class="row">
                                <div class="col-md-12 ">
                                    <div class="card-user pageContainer pageEventAssignment">
                                        <div class="card-header pgHederSpceArnd">
                                            <h5 class="card-title text-center">{translate("Faculty_Management")}</h5>
                                            <p>Default Language: {Helper.languages.find(language => language.langCode === langSelected)?.name}</p>
                                        </div>

                                        <div class="card-header">
                                            <div class="card-body">
                                                <Table responsive>
                                                    <thead>
                                                        <tr>
                                                            <th>SNo.</th>
                                                            <th>Name</th>
                                                            <th>Email</th>
                                                            <th>Contact</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {registeredFaculties && registeredFaculties.length > 0 ? (
                                                            registeredFaculties.map((faculty, i) => (
                                                                <tr key={i}>
                                                                    <td>{i + 1}</td>
                                                                    <td>{faculty.teacher_name}</td>
                                                                    <td>{faculty.email && faculty.email.replace(/\[at\]/g, '@').replace(/\[dot\]/g, '.')}</td>
                                                                    <td>{faculty.mobile}</td>
                                                                    <td>{faculty.isActive === true ? 'Active' : 'Inactive'}</td>
                                                                    <td>
                                                                        {faculty.isActive === true ?
                                                                            <Button onClick={() => handleActiveStatus(faculty.email, 2, false)} className="btn-danger">{translate("Deactivate")}</Button>
                                                                            :
                                                                            <Button onClick={() => handleActiveStatus(faculty.email, 1, true)} className="btn-success">{translate("Activate")}</Button>
                                                                        }  </td>
                                                                </tr>
                                                                        
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="6" className="text-center">Data not found.</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>
                                            {totalPages > 1 ?
                                                <div className="mb-3 text-center">
                                                    <button className="mx-2" onClick={(e) => { e.preventDefault(); handlePageChange(currentPage - 1) }} disabled={currentPage === 1}>{translate("Previous")}</button>
                                                    <span className="mx-2">{`Page ${currentPage} of ${totalPages}`}</span>
                                                    <button className="mx-2" onClick={(e) => { e.preventDefault(); handlePageChange(currentPage + 1) }} disabled={currentPage === totalPages}>{translate("Next")}</button>
                                                </div>
                                                : ""}
                                        </div>

                                        <div class="card-header">
                                            <h5 class="card-title text-center mb-3">{translate("Add_new_faculty")}</h5>
                                            <div className="mt-3 text-right"><VirtualKeyboard lang={langSelected}   /></div>
                                            {/* <Form onSubmit={handleSubmit}> */}
                                                <Row>
                                                    <Col md="6"><FormGroup>UDISE Code: <p>{initialValues.udise_id}</p></FormGroup></Col>
                                                    <Col md="6">
                                                        <FormGroup>{translate("School_Name")}: <p>{initialValues.school_name}</p></FormGroup>
                                                    </Col>
                                                    <Col md="12">
                                                        <Row>
                                                            {InputFields.slice(0, 4)?.map((fieldConfig) =>
                                                                renderInputFields(fieldConfig, setFieldValue, 6)
                                                            )}
                                                        </Row>
                                                        <Row>
                                                            {renderInputFields(InputFields[4], setFieldValue, 6)}
                                                        </Row>
                                                        <Row>
                                                            {renderInputFields(InputFields[5], setFieldValue, 6)}
                                                        </Row>

                                                        <Col md={12} className="text-center mt-3">
                                                            <FormGroup>
                                                            <button
                                                                className="btn btn-primary"
                                                                type="submit" disabled={isSubmitting==false?isEmpty:isSubmitting} 
                                                                onClick={(e)=>handleSubmit(e)}
                                                            >
                                                                {" "}
                                                                {translate("Submit")}{" "}
                                                            </button>
                                                            </FormGroup>
                                                        </Col>
                                                    </Col>
                                                </Row>
                                            {/* </Form> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Form>
            )}
        </Formik>
    );
}

export default FacultyManagement;
